import { Label } from 'react-bootstrap';

export const getBoolean = (val: boolean, yesIsBad: boolean = true) => {
    if (val == null) {
        return '[not answered]';
    }

    switch (val) {
        case false:
            return <Label bsStyle={yesIsBad ? 'success' : 'danger'} style={{ width: '100%', fontSize: '14px', display: 'inline-block', padding: '3px 0' }}>No</Label>;
        case true:
            return <Label bsStyle={yesIsBad ? 'danger' : 'success'} style={{ width: '100%', fontSize: '14px', display: 'inline-block', padding: '3px 0' }}>Yes</Label>;
        default:
            return <Label bsStyle='default' style={{ width: '100%', fontSize: '14px', display: 'inline-block', padding: '3px 0' }}>Unknown</Label>;
    }
};

export const getYesNoUnknown = (val: string, yesIsBad: boolean = true) => {
    if (val == '' || val == null) {
        return '[not answered]';
    }

    switch (val) {
        case 'No':
            return <Label bsStyle={yesIsBad ? 'success' : 'danger'} style={{ width: '100%', fontSize: '14px', display: 'inline-block', padding: '3px 0' }}>{val}</Label>;
        case 'Yes':
            return <Label bsStyle={yesIsBad ? 'danger' : 'success'} style={{ width: '100%', fontSize: '14px', display: 'inline-block', padding: '3px 0' }}>{val}</Label>;
        default:
            return <Label bsStyle='default' style={{ width: '100%', fontSize: '14px', display: 'inline-block', padding: '3px 0' }}>{val}</Label>;
    }
};

export const getMedicalStatus = (val: string) => {
    if (val == '' || val == null) {
        return '[not answered]';
    }

    switch (val) {
        case "I don't know":
            return <Label bsStyle='default' style={{ width: '100%', fontSize: '14px', display: 'inline-block', padding: '3px 0' }}>Unknown</Label>;
        case "No":
            return <Label bsStyle='success' style={{ width: '100%', fontSize: '14px', display: 'inline-block', padding: '3px 0' }}>Never</Label>;
        case "Yes":
            return <Label bsStyle='danger' style={{ width: '100%', fontSize: '14px', display: 'inline-block', padding: '3px 0' }}>Yes</Label>;
        case "Treated in the past":
            return <Label bsStyle='warning' style={{ width: '100%', fontSize: '14px', display: 'inline-block', padding: '3px 0' }}>Treated in past</Label>;
        case "Still being treated":
            return <Label bsStyle='danger' style={{ width: '100%', fontSize: '14px', display: 'inline-block', padding: '3px 0' }}>Still being treated</Label>;
        default:
            return '[not answered]';
    }
};

export const getString = (value: string) => {
    if (value == '' || value == null) {
        return '[not answered]';
    }

    return value;
};

export const getNumber= (value: number) => {
    if (value == null) {
        return '[not answered]';
    }

    return value;
};